export default __webpack_public_path__ + "static/media/billing.d5d58d6c.svg";